<template>
  <div>
    <v-data-table
      v-if="files && files.length > 0"
      :headers="headers"
      :items="files"
      :items-per-page="-1"
      hide-default-footer
      class="elevation-1 mt-2"
      @click:row="openFile"
    >
      <template v-slot:item.icon="{ item }">
        <v-progress-circular
          v-if="item._opening"
          indeterminate
          size="24"
          color="primary"
        ></v-progress-circular>
        <v-icon v-else>mdi {{ getFileIcon(item.filename) }}</v-icon>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ $formatDateAndHourMinute(item.createdAt) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          :loading="item._loadingDeleteFile"
          icon
          @click.stop="deleteFile(item)"
        >
          <v-icon color="error">mdi mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <div
      v-if="!files || files.length === 0"
      class="text-center grey--text mt-4"
    >
      Ei tiedostoja
    </div>
  </div>
</template>

<script>
export default {
  name: "IlmoitusFilesTable",
  props: {
    files: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: "", value: "icon", sortable: false, width: "50px" },
        { text: "Nimi", value: "filename" },
        { text: "Lisätty", value: "createdAt" },
        { text: "Lisääjä", value: "createdBy.user" },
        { text: "", value: "actions", sortable: false, width: "50px" },
      ],
    };
  },
  methods: {
    getFileIcon(filename) {
      if (!filename) return "mdi-file";
      const extension = filename.split(".").pop();
      const icons = {
        pdf: "mdi-file-document",
        jpg: "mdi-file-image",
        jpeg: "mdi-file-image",
        png: "mdi-file-image",
        gif: "mdi-file-image",
        bmp: "mdi-file-image",
        mp3: "mdi-file-music",
        wav: "mdi-file-music",
        mp4: "mdi-file-video",
        mov: "mdi-file-video",
        avi: "mdi-file-video",
        doc: "mdi-file-word",
        docx: "mdi-file-word",
        xls: "mdi-file-excel",
        xlsx: "mdi-file-excel",
        ppt: "mdi-file-powerpoint",
        pptx: "mdi-file-powerpoint",
      };
      return icons[extension.toLowerCase()] || "mdi-file";
    },
    openFile(file) {
      this.$emit("open", file);
    },
    deleteFile(file) {
      this.$emit("delete", file);
    },
  },
};
</script>

<style scoped>
::v-deep tbody tr {
  cursor: pointer;
}
</style>
